import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import BoxDeliveriesTable from "@/components/logistics/box-deliveries/box-deliveries-table";

const boxDeliveriesSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  status: z.string().optional(),
});

export const Route = createFileRoute(
  "/_authenticated/logistics/box-deliveries/",
)({
  validateSearch: boxDeliveriesSearchSchema,
  component: BoxDeliveriesPage,
});

function BoxDeliveriesPage() {
  const searchParams = Route.useSearch();

  return (
    <div className="flex-1 flex flex-col min-h-0">
      <BoxDeliveriesTable
        currentPage={searchParams.page}
        pageSize={10}
        basePath="/logistics/box-deliveries"
        searchParams={searchParams}
      />
    </div>
  );
}
